var localization = {};
var language = "en";

function getText(key, values) {
    var str = localization[language][key];

    if (values) {
        for (var i = 0; i < values.length; i++) {
            str=str.replace("[" + i + "]", values[i]);
        }
    }
    return str;
}

//English
localization.en = {};

localization.en.powerUpTitle0 = "Level up";
localization.en.powerUpTitle1 = "Wild gem";
localization.en.powerUpTitle2 = "Shifting";
localization.en.powerUpTitle3 = "Revive";

localization.en.powerUpText0 = "Turn all level 1 gems into level 2 gems.";
localization.en.powerUpText1 = "Turn the upcoming gem into a wild gem.";
localization.en.powerUpText2 = "Rearrange gems on the board.";
localization.en.powerUpText3 = "Undo your last 20 moves.";

localization.en.ad = "Watch an ad to activate.";

localization.en.noAdsTitle = "Not available";
localization.en.noAdsText = "No ads are available at this moment. Please try again in a few seconds.";
localization.en.noInternetTitle = "No Internet";
localization.en.noInternetText = "Make sure you are connected to the Internet.";

localization.en.adBlockerTitle = "Ad blocker";
localization.en.adBlockerText = "Please disable your ad blocker and refresh the page.";

localization.en.oopsTitle = "Oops";
localization.en.oopsText = "Something went wrong. Please try again in a few seconds.";

localization.en.share = "Play Gem·11!";
localization.en.shareScore = "I scored [0] points in Gem·11. Can you beat me?";
